import { IconProps } from './Icon';

export const LeftArrowOutlineIcon = ({
  width,
  height,
  className,
  color,
}: IconProps) => (
  <svg
    className={className}
    color={color}
    height={height}
    id="Capa_1"
    version="1.1"
    viewBox="0 0 24 24"
    width={width}
    x="0px"
    xmlns="http://www.w3.org/2000/svg"
    y="0px"
  >
    <path
      d="m15.4559 5.81284-6.18716 6.18716 6.18716 6.1872c.061.061.1144.1268.1602.1961.3203.4852.2669 1.1445-.1602 1.5717-.4881.4881-1.2796.4881-1.7678 0l-7.07101-7.0711c-.0293-.0293-.057-.0599-.08303-.0917-.18225-.2224-.28308-.5021-.28308-.7922 0-.3315.13169-.6494.36611-.8839l7.07101-7.07103c.4882-.48815 1.2797-.48815 1.7678 0 .061.06102.1144.12678.1602.19609.3203.48519.2669 1.14454-.1602 1.57168z"
      fill="rgb(0,0,0)"
    />
  </svg>
);
